import(/* webpackMode: "eager" */ "/var/www/alodata/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/alodata/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/var/www/alodata/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Readex_Pro\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"display\":\"swap\",\"fallback\":[\"Arial\",\"sans-serif\"]}],\"variableName\":\"readexPro\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/alodata/src/components/ClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/alodata/src/components/PageViewTracker.tsx");
